// Shared by the weekly show and conference players. Public playback endpoint;
// never send an account API token or ingest credentials to the browser.
export async function fetchLiveInput(baseUrl, inputId, signal) {
  const response = await fetch(`${baseUrl}/${inputId}/lifecycle`, {
    signal, cache: "no-store", credentials: "omit"
  })
  if (!response.ok) throw new Error(`Cloudflare status: HTTP ${response.status}`)
  const state = await response.json()
  if (state.isInput !== true || typeof state.live !== "boolean" ||
      (state.live && !/^[a-f0-9]{32}$/.test(state.videoUID))) {
    throw new Error("Invalid Cloudflare lifecycle response")
  }
  return state
}
